/** What the server calls a move whose attacker picks one of the Defending Pokémon's energy cards (Whirlpool)... */
export const CHOOSES_DEFENDING_ENERGY = 'defending_energy';
/** ...or one of the opponent's benched Pokémon to switch in (Lure)... */
export const CHOOSES_OPPONENT_BENCH = 'opponent_bench';
/** ...or one of the Defending Pokémon's attacks to block (Amnesia) or copy (Metronome)... */
export const CHOOSES_DEFENDING_ATTACK = 'defending_attack';
/** ...or a type of energy for a Weakness or Resistance (Conversion 1 and 2), from the move's energy_types. */
export const CHOOSES_ENERGY_TYPE = 'energy_type';

/** The Defending Pokémon's attacks, which Amnesia can block or Metronome copy: no Powers, and none for Clefairy Doll. */
export const defendingAttacks = (opponent) => opponent.getIn(['activePokemon', 'card', 'moves'])
  ? opponent.getIn(['activePokemon', 'card', 'moves']).filter(move => move.get('is_attack'))
  : null;

/**
 * What attacking with `move` needs from the player besides the tap, given the opponent (their activePokemon and
 * bench, from selectOpponent).
 *
 * - `{ pick: CHOOSES_* }`: the player picks first, because the choices differ.
 * - `{ picks: { energyAttachmentId } }`, `{ picks: { benchPosition } }` or `{ picks: { defendingMoveId } }`: the
 *   pick is made for them, as there is only one choice (every energy card the same, one benched Pokémon, one
 *   attack).
 * - `{ picks: {} }`: nothing to pick; the move picks nothing, or there is nothing to pick from.
 */
export const attackChoice = (move, opponent) => {
  const chooses = move.get('chooses');

  if (chooses === CHOOSES_DEFENDING_ENERGY) {
    const energy = opponent && opponent.getIn(['activePokemon', 'energyAttachments']);
    if (!energy || energy.size === 0) {
      return { picks: {} };
    }
    if (energy.map(attachment => attachment.get('card_id')).toSet().size === 1) {
      return { picks: { energyAttachmentId: energy.first().get('id') } };
    }
    return { pick: chooses };
  }

  if (chooses === CHOOSES_OPPONENT_BENCH) {
    const benched = opponent && opponent.getIn(['bench', 'cards']);
    if (!benched || benched.size === 0) {
      return { picks: {} };
    }
    if (benched.size === 1) {
      return { picks: { benchPosition: benched.first().get('order') } };
    }
    return { pick: chooses };
  }

  if (chooses === CHOOSES_DEFENDING_ATTACK) {
    const attacks = opponent && defendingAttacks(opponent);
    if (!attacks || attacks.size === 0) {
      return { picks: {} };
    }
    if (attacks.size === 1) {
      return { picks: { defendingMoveId: attacks.first().get('id') } };
    }
    return { pick: chooses };
  }

  if (chooses === CHOOSES_ENERGY_TYPE) {
    return { pick: chooses };
  }

  return { picks: {} };
};
